import { useState } from "react";
import SectionHeading from "./SectionHeading";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daf7riptto0ceqqnh7c0";

const values = [
  {
    icon: "ri-camera-line",
    title: "实拍优先",
    desc: "只收现场直出与实拍生图，标注拍摄场景与事件，让你看到最真实的现场。",
  },
  {
    icon: "ri-focus-3-line",
    title: "快速检索",
    desc: "按事件、分类与关键词组织图集，找图一步到位，不用在几十页里来回翻。",
  },
  {
    icon: "ri-shield-check-line",
    title: "尊重版权",
    desc: "图片标注来源，转载注明出处，商业使用先授权，鼓励投稿者署名收录。",
  },
];

const reviews = [
  {
    name: "追更的夜猫子",
    desc: "上月底更新超快，红毯生图当晚就凑齐了，放大看礼服细节真的很清楚，存了不少当壁纸。",
  },
  {
    name: "杂志狂魔",
    desc: "按主题分类这点太省事了，机场穿搭和综艺表情包都是按合集一口气看的，找图再也不翻到眼花。",
  },
  {
    name: "现场摄影爱好者",
    desc: "投过一次稿，编辑反馈很快，采纳后标了来源还带我备注了场景，体验很不错。",
  },
];

export default function AboutSection() {
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [status, setStatus] = useState<{ kind: "idle" | "loading" | "ok" | "error"; msg: string }>({
    kind: "idle",
    msg: "",
  });

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honey = String(data.get("website_alt") || "").trim();
    if (honey) {
      setStatus({ kind: "ok", msg: "订阅成功，热点现场直击将第一时间推送给你。" });
      form.reset();
      setEmail("");
      return;
    }
    setStatus({ kind: "loading", msg: "正在提交…" });
    const payload = new FormData();
    payload.append("email", String(data.get("email") || "").trim());
    try {
      const res = await fetch(SUBMIT_ADDR, { method: "POST", body: payload });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      if (res.ok && parsed?.code === "OK") {
        setStatus({ kind: "ok", msg: "订阅成功，热点现场直击将第一时间推送给你。" });
        form.reset();
        setEmail("");
      } else {
        setStatus({
          kind: "error",
          msg: serverMsg.includes("spam") || serverMsg.includes("form data is spam")
            ? "提交未通过，请检查后重试。"
            : serverMsg || "提交失败，请稍后再试。",
        });
      }
    } catch {
      setStatus({ kind: "error", msg: "网络异常，请稍后再试。" });
    }
  };

  return (
    <>
      <section id="about" className="w-full bg-background-50 py-14 md:py-20 scroll-mt-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_1fr] gap-8 lg:gap-12">
            <div>
              <SectionHeading
                kicker="ABOUT 关于图集"
                title="关于吃瓜图集"
                desc="一个把全网活动现场实拍、路透照与高清生图按事件整理聚合的图集站。不用东拼西凑，点开就能看各路现场直出。"
              />

              <p className="mt-6 text-sm leading-relaxed text-foreground-600">
                我们从「找图太费劲」出发，希望把散落在各个现场的照片按事件收拢成册。每一次红毯、发布会、综艺录制或音乐现场，
                编辑部都会及时整理现场生图与抓拍瞬间，随事件进度持续补充高清画面，让关心的人不必错过任何名场面。
              </p>

              <h3 className="mt-8 font-heading font-bold text-foreground-950 text-lg">我们的内容原则</h3>
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
                {values.map((v) => (
                  <div key={v.title} className="p-4 rounded-lg bg-background-100 border border-background-200">
                    <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                      <i className={`${v.icon} text-lg`}></i>
                    </span>
                    <h4 className="mt-3 font-semibold text-foreground-950 text-sm">{v.title}</h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex flex-col">
              <h3 className="font-heading font-bold text-foreground-950 text-lg">来自用户的口碑</h3>
              <div className="mt-4 space-y-3 flex-1">
                {reviews.map((r, i) => (
                  <figure key={i} className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200">
                    <span className="flex gap-0.5 text-accent-500 text-sm">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </span>
                    <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{r.desc}”</blockquote>
                    <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 font-bold">
                        {r.name.slice(0, 1)}
                      </span>
                      {r.name}
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center rounded-2xl overflow-hidden bg-foreground-950">
            <div className="p-6 md:p-10">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold text-background-50 bg-accent-500 whitespace-nowrap">
                <i className="ri-focus-2-line"></i> 投稿与合作
              </span>
              <h2 className="mt-5 text-2xl md:text-3xl font-heading font-bold text-background-50">有现场，有线索？</h2>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-background-100/85 max-w-lg">
                拍到活动现场实拍、路透或抓拍瞬间，欢迎投稿收录进对应事件图集并署名。商务合作、转载授权与编辑沟通，也随时可以联系我们。
              </p>

              <div className="mt-6 space-y-3 text-sm">
                <a href="mailto:hello@chiguatuji.example" className="flex items-center gap-3 text-background-100 hover:text-accent-300 transition">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                    <i className="ri-mail-line"></i>
                  </span>
                  hello@chiguatuji.example
                </a>
                <a href="#contact" onClick={(e) => e.preventDefault()} className="flex items-center gap-3 text-background-100 hover:text-accent-300 transition cursor-pointer">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                    <i className="ri-chat-3-line"></i>
                  </span>
                  官方私信 · 工作日内回复
                </a>
              </div>
            </div>

            <div className="p-6 md:p-10 border-l border-background-50/10">
              <h3 className="font-heading font-bold text-background-50 text-lg">订阅现场直击</h3>
              <p className="mt-2 text-sm text-background-100/75">
                留下邮箱，热门事件图集与高清生图更新时第一时间提醒你，不错过任何名场面。
              </p>

              <form data-readdy-form="吃瓜图集更新订阅" onSubmit={submit} className="mt-5 space-y-3" noValidate>
                <div className="site-field-aux" aria-hidden="true">
                  <label htmlFor="website_alt">公司网站</label>
                  <input
                    type="text"
                    id="website_alt"
                    name="website_alt"
                    value={hp}
                    onChange={(e) => setHp(e.target.value)}
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入你的邮箱地址"
                    className="flex-1 min-w-0 h-12 px-4 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 text-sm placeholder:text-background-100/50 outline-none focus:border-accent-400"
                  />
                  <button
                    type="submit"
                    disabled={status.kind === "loading"}
                    className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-400 disabled:opacity-60 transition whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-send-plane-line"></i>
                    {status.kind === "loading" ? "提交中…" : "立即订阅"}
                  </button>
                </div>
                {status.kind === "ok" && (
                  <p className="text-sm text-accent-300 flex items-center gap-1.5">
                    <i className="ri-checkbox-circle-line"></i>
                    {status.msg}
                  </p>
                )}
                {status.kind === "error" && (
                  <p className="text-sm text-primary-400 flex items-center gap-1.5">
                    <i className="ri-error-warning-line"></i>
                    {status.msg}
                  </p>
                )}
                <p className="text-xs text-background-100/50">
                  提交即表示同意我们仅将邮箱用于图集更新通知，可随时退订。
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}